import { render, staticRenderFns } from "./ConfirmDelete.vue?vue&type=template&id=357a033f&scoped=true&"
import script from "./ConfirmDelete.vue?vue&type=script&lang=js&"
export * from "./ConfirmDelete.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDelete.vue?vue&type=style&index=0&id=357a033f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357a033f",
  null
  
)

export default component.exports